export const createPatchPayload = (updates) =>
  Object.entries(updates).map(([prop, val]: [string, { op: string; value: unknown }]) => ({
    op: val.op,
    [prop]: val.value,
  }));
